import React from 'react';
import styled from 'styled-components';
import { theme } from '../../theme';
import { Link as ScrollLink } from 'react-scroll';

// You can replace this with your own background image
const heroBackground = 'https://images.unsplash.com/photo-1502082553048-f009c37129b9?ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80';

const HeroContainer = styled.div`
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.6),
    rgba(${theme.colors.primaryRGB}, 0.9)
  ), url(${heroBackground}) no-repeat center center;
  background-size: cover;
  height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #fff;
  text-align: center;
  padding: 0 20px;
  
  @media screen and (max-width: 768px) {
    height: 90vh;
  }
`;

const HeroContent = styled.div`
  max-width: 1000px;
  margin-top: 80px;
  
  @media screen and (max-width: 960px) {
    margin-top: 60px;
    padding: 0 10px;
  }
`;

const HeroH1 = styled.h1`
  font-size: 3.5rem;
  font-weight: bold;
  color: #fff;
  margin-bottom: 24px;
  letter-spacing: 1px;
  font-family: ${theme.fonts.heading};
  
  @media screen and (max-width: 768px) {
    font-size: 2.5rem;
  }
  
  @media screen and (max-width: 480px) {
    font-size: 2rem;
  }
`;

const HeroSubtitle = styled.p`
  font-size: 1.5rem;
  color: ${theme.colors.light};
  max-width: 800px;
  margin: 0 auto 40px;
  
  @media screen and (max-width: 768px) {
    font-size: 1.2rem;
  }
`;

const HeroText = styled.p`
  font-size: 1.2rem;
  color: ${theme.colors.light};
  max-width: 800px;
  margin: 0 auto 40px;
  line-height: 1.5;
  
  @media screen and (max-width: 768px) {
    font-size: 1rem;
  }
`;

const HeroBtnWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 20px;
  
  @media screen and (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }
`;

const Button = styled(ScrollLink)`
  border-radius: ${theme.borderRadius};
  background: ${props => props.primary ? theme.colors.accent : 'transparent'};
  white-space: nowrap;
  padding: ${props => props.big ? '14px 48px' : '12px 30px'};
  color: ${props => props.primary ? '#ffffff' : '#ffffff'};
  font-size: ${props => props.fontBig ? '20px' : '16px'};
  font-weight: 600;
  border: ${props => props.primary ? 'none' : `2px solid ${theme.colors.accent}`};
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.3s ease-in-out;
  text-decoration: none;
  
  &:hover {
    transform: translateY(-5px);
    background: ${props => props.primary ? theme.colors.accentLight : 'rgba(255, 255, 255, 0.2)'};
  }
`;

const HeroSection = () => {
  return (
    <HeroContainer id="home">
      <HeroContent>
        <HeroH1>Rewilding Psychotherapy and Movement for Wellbeing</HeroH1>
        <HeroSubtitle>Therapy that goes beyond the conventional.</HeroSubtitle>
        <HeroText>
          We offer nature-based psychotherapy, coaching and movement coaching for individuals, 
          groups, schools, and organisations. Rewild your mind. Rebuild your body. Remember your self.
        </HeroText>
        <HeroBtnWrapper>
          <Button 
            to="services" 
            smooth={true} 
            duration={500} 
            spy={true} 
            exact="true" 
            offset={-80}
            primary={true}
            big={true}
          >
            Our Services
          </Button>
          <Button 
            to="contact" 
            smooth={true} 
            duration={500} 
            spy={true} 
            exact="true" 
            offset={-80}
            primary={false}
            big={true}
          >
            Get In Touch
          </Button>
        </HeroBtnWrapper>
      </HeroContent>
    </HeroContainer>
  );
};

export default HeroSection;